export const datePickerMixin = {
    methods: {
        notAfterToday(date) {
            return date > new Date();
        },
        notBeforeStart(date) {
            // End date must be < start and <= today
            const maxDays = 40;
            let maxDate = new Date(this.formData.start_date);
            maxDate.setDate(maxDate.getDate() + maxDays)

            return (
                date < new Date(new Date(this.formData.start_date).setHours(0, 0, 0, 0)) || date > maxDate || date > new Date()
            );
        },
        checkEndDate() {
            const maxDays = 40;

            const startDate = new Date(this.formData.start_date);
            const endDate = new Date(this.formData.end_date);

            let maxDate = startDate;
            maxDate.setDate(maxDate.getDate() + maxDays);

            if (
                new Date(this.formData.start_date) >=
                new Date(new Date(this.formData.end_date).setHours(0, 0, 0, 0))
            ) {
                // If start > end, set end = start
                this.formData.end_date = this.formData.start_date;
            } else if (endDate > maxDate) {
                // If end > maxDays, set end = maxDate
                this.formData.end_date = this.moment(maxDate).format("YYYY-MM-DD");
            }
        },
        notAfterNow(date) {
            const chosenTime = date.getTime() / 1000;
            const maxTime = new Date().getTime() / 1000;
            return chosenTime > maxTime
        }
    }
};